<template>
  <div
    :class="{'deleted': message.deleted}"
    class="e-chat__message"
  >
    <div class="e-chat__message__hidden-header" :data-id="message.id"></div>
    <div 
      :class="{ 'emoji-only': isEmojiOnly }"
      class="e-chat__message__content"
    >
      <div class="e-chat__message__preview" v-for="attachment in message.attachments" :key="attachment.id">
        <div v-if="attachment.filename.split('.').pop() === 'pdf'" class="pdf">
          <IconPDF class="pdf-icon" />
          <a target="_blank" :href="attachmentLink(attachment.id)">{{ attachment.filename }}</a>
        </div>
        <div v-else class="image">
          <a target="_blank" :href="attachmentLink(attachment.id)">
            <img 
              :src="downloadLink(attachment.id)"
              alt="preview"
              loading="lazy"
              style="max-width: 200px;max-height: 300px"/>
          </a>
        </div>
      </div>
      <span
        class="e-chat__message__text"
        v-html="message.text"
      />
    </div>
    <div class="e-chat__message__date">
      <div
        :class="{ read: message.read }">
        <IconCheck />
      </div>
      <time :datetime="message.createdAt" role="presentation" 
          :data-id="message.id">
        {{
          (typeof message.createdAt === 'object'
            ? message.createdAt.toISOString()
            : message.createdAt) | time(language)
        }}
      </time>
    </div>
    <IconTrash
      v-if="deletable"
      role="presentation"
      class="e-chat__message-delete"
      @click="deleteMessage"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from 'api'
import IconTrash from 'assets/icons/trash.svg'
import IconCheck from 'assets/icons/chat-check-double.svg'
import IconPDF from 'assets/icons/pdf_icon.svg'
import { restapi } from 'api/config'

export default {
  components: {
    IconTrash,
    IconCheck,
    IconPDF
  },
  props: {
    message: {
      default: () => ({}),
      type: Object
    },
    deletable: {
      default: false,
      type: Boolean
    },
    chatId: {
      type: String
    }
  },
  
  computed: {
    ...mapGetters(['currentUserChat', 'language', 'userInfo']),

    isEmojiOnly() {
      let text = this.message.text
      if (!text) {
        return false
      }
      const trimmed = text.trim()
      const emojiRegex = /^(?:\p{Extended_Pictographic}|\p{Emoji_Component}|\u200d|\ufe0f)+$/u

      return emojiRegex.test(trimmed)
    }
  },

  methods: {
    deleteMessage () {
      this.$confirm('Nachricht löschen', this.$t('system.warning'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        api.call('deleteChatMessage', { id: this.message.id, rootId: this.currentUserChat.id })
      }).catch(() => { })
    },

    attachmentLink(attachmentId) {
      if(attachmentId) {
        if(restapi[process.env.NODE_ENV]){
          return `${restapi[process.env.NODE_ENV].url}/chat/${this.userInfo.id}/${this.chatId}/message/${this.message.id}/attachments/${attachmentId}/view`
        }
      }
      return ""
    },
    downloadLink(attachmentId) {
      if(attachmentId) {
        if(restapi[process.env.NODE_ENV]){
          return `${restapi[process.env.NODE_ENV].url}/chat/${this.userInfo.id}/${this.chatId}/message/${this.message.id}/attachments/${attachmentId}/download`
        }
      }
      return ""
    },
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/ChatMessage';
</style>
